<template>
  <div>
    <v-card-title>{{$t('message.hse.versionHistory')}}</v-card-title>
    <v-divider class="mb-4"></v-divider>
    <v-card-text>
      <v-simple-table dense class="bordered--table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left" width="15%">{{ $t('message.hse.versionLabel')}}</th>
              <th class="text-left" width="10%">{{ $t('message.hse.modifiedOn') }}</th>
              <th class="text-left" width="15%">{{ $t('message.hse.modifiedBy') }}</th>
              <th class="text-left" width="10%">{{ $t('message.hse.size') }}</th>
              <th class="text-left" width="50%">{{ $t('message.common.comments') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in versionHistory" :key="i">
              <td><a @click="openVersionLink(item.url)" style="text-decoration: underline;">{{item.versionlabel}}</a></td>
              <td>{{item.modified_on}}</td>
              <td>{{item.modifiedby}}</td>
              <td>{{item.size}}</td>
              <td style="word-break: break-all;">{{item.checkincomment}}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </div>
</template>
<script>
export default {
  props: ['versionHistory'],
  methods: {
    openVersionLink (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
